import { render, staticRenderFns } from "./TrafficSources.vue?vue&type=template&id=bf62acd2&scoped=true"
import script from "./TrafficSources.vue?vue&type=script&lang=js"
export * from "./TrafficSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf62acd2",
  null
  
)

export default component.exports